module.exports = __webpack_public_path__ + "static/tabs-buttons-do-b4031e0c3f2fa1be6765110fe86dda8c.png";